import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';

const isDebugEnabled = () => {
  if (process.env.NODE_ENV === 'development') return true;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('debug') === 'true';
  } catch {
    return false;
  }
};

const DebugPanel = ({ generation }) => {
  if (!isDebugEnabled()) return null;

  return (
    <Accordion sx={{ mt: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BugReportOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Typography variant="body2" color="text.secondary">
            Debug Panel
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box
          component="pre"
          sx={{
            fontSize: '0.75rem',
            fontFamily: 'monospace',
            backgroundColor: '#f5f5f5',
            padding: 2,
            borderRadius: 1,
            overflow: 'auto',
            maxHeight: 400,
            textAlign: 'left',
          }}
        >
          {JSON.stringify(generation, null, 2)}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default DebugPanel;
